import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 查询用户/商家管理列表
    get: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/getMemberList`, params),
    //修改用户/商家
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/updateMember`, params),
    //删除用户/商家
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/deleteMember`, params),
}